import { useEffect, useState } from "react";
import { adminApi, apiError } from "@/admin/api";
import { toast } from "sonner";
import { Save, ShieldAlert, CheckCircle2, XCircle } from "lucide-react";

export default function Payments() {
  const [p, setP] = useState(null);
  useEffect(() => { adminApi.get("/admin/payments").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return <div className="text-gray-400">Loading…</div>;

  const save = async () => {
    try { await adminApi.put("/admin/payments", { mode: p.mode, key_id: p.key_id, webhook_url: p.webhook_url }); toast.success("Payment settings saved"); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Payment Settings <span className="text-xs font-normal text-gray-400">(Super Admin)</span></h1>
        <button data-testid="payments-save" onClick={save} className="inline-flex items-center gap-2 rounded-lg bg-[hsl(13_65%_54%)] text-white px-4 py-2 text-sm font-medium"><Save size={15} /> Save</button>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex gap-3 text-sm text-amber-800">
        <ShieldAlert size={18} className="shrink-0 mt-0.5" />
        <div>Razorpay <strong>Key Secret</strong> and <strong>Webhook Secret</strong> are stored only in secure backend environment variables — never here, never sent to the browser. This screen manages non-secret configuration only.</div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2 text-sm">
            {p.razorpay_active ? <CheckCircle2 size={16} className="text-emerald-600" /> : <XCircle size={16} className="text-gray-400" />}
            Razorpay {p.razorpay_active ? "Active" : "Inactive"}
          </div>
          <div className="flex items-center gap-2 text-sm">
            {p.secret_configured ? <CheckCircle2 size={16} className="text-emerald-600" /> : <XCircle size={16} className="text-gray-400" />}
            Key Secret {p.secret_configured ? "Configured" : "Not set"}
          </div>
        </div>
        <div><label className="text-xs font-semibold text-gray-500 uppercase">Mode</label>
          <select data-testid="pay-mode" value={p.mode} onChange={(e) => setP({ ...p, mode: e.target.value })} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm">
            <option value="test">Test Mode</option><option value="live">Live Mode</option>
          </select>
        </div>
        <div><label className="text-xs font-semibold text-gray-500 uppercase">Razorpay Key ID (public)</label>
          <input data-testid="pay-keyid" value={p.key_id} onChange={(e) => setP({ ...p, key_id: e.target.value })} placeholder="rzp_test_xxxx" className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
        <div><label className="text-xs font-semibold text-gray-500 uppercase">Webhook URL</label>
          <input data-testid="pay-webhook" value={p.webhook_url} onChange={(e) => setP({ ...p, webhook_url: e.target.value })} placeholder="https://.../api/razorpay/webhook" className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
        <p className="text-xs text-gray-400">To activate live payments, add RAZORPAY_KEY_ID / RAZORPAY_KEY_SECRET / RAZORPAY_WEBHOOK_SECRET to the backend environment. Webhooks & reconciliation ship in the next phase.</p>
      </div>
    </div>
  );
}
